// extracted by mini-css-extract-plugin
export default {"container":"Data_container__MGCbz","rules_container":"Data_rules_container__NxNaQ","rules_block":"Data_rules_block__8szUu"};